<template>
  <div id="app">
    <Header></Header>
    <main class="app-main">
      <router-view/>
    </main>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  min-height: 100%;
  background: #f8fafc;
  color: #1e293b;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
    "PingFang SC", "Microsoft YaHei", sans-serif;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-main {
  flex: 1;
  /* 为固定头部预留高度：桌面 64px，移动 56px */
  padding-top: 64px;
}

@media (max-width: 767px) {
  .app-main {
    padding-top: 56px;
  }
}

a {
  color: #0ea5e9;
}

a:hover {
  color: #0284c7;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue